import { Observable } from 'rxjs';
import { HttpEvent, HttpEventType } from '@angular/common/http';

type Upload<T> = Observable<HttpEvent<T>>;

/**
 * Wait for an upload with tracked progress to complete.
 *
 * This returns a promise that returns only once a response event is received, and returns the body of that response.
 *
 * @param upload The upload to watch
 * @param progressCallback If provided, this callback is called with values from 0.0 to 1.0 showing upload progress until the upload completes.
 * @returns The body of the response if and when the upload completes.
 * @throws If the upload fails, this will throw whatever error was thrown.
 */
export function waitForUploadComplete<T = any>(upload: Upload<T>, progressCallback?: (progress: number) => void): Promise<T> {
  return new Promise((resolve, reject) => {
    upload.subscribe((event: HttpEvent<T>) => {
      if (event.type === HttpEventType.UploadProgress) {
        progressCallback?.(event.loaded / event.total);
      }
      if (event.type === HttpEventType.Response) {
        resolve(event.body)
      }
    }, (err) => {
      reject(err);
    });
  });
}
